export default function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style, background: "black", marginLeft: "20px", zIndex: 50 }}
            onClick={onClick}
        />
    );
}